import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex w-100 align-items-center pt-4 pb-2" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Cerrar ")

import Modal from "@/components/Modal.vue";
import IdentificatorsControl from "@/omnichannel/components/ticketSidebar/IdentificatorsControl.vue";
import { CallDataModule } from "@/store/modules/CallData";
import { IdentificationModule } from "@/store/modules/Identification";
import { ref, watch } from "vue";
//emits

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "update:modelValue", payload: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	modelValue: boolean;
}


// props


// Data
const loading = ref(false);

// Methods
async function updateUserData() {
	loading.value = true;
	await CallDataModule.getCallCenterClient(
		CallDataModule.activeCall.call_number
	);
	loading.value = false;
}
watch(
	() => props.modelValue,
	async (now, last) => {
		if (now && !last) {
			loading.value = true;
			await IdentificationModule.requestFoundCoincidences({
				client: CallDataModule.user?._id ?? "",
				identifications: CallDataModule.user?.identification ?? [],
			});
			loading.value = false;
		}
	}
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.modelValue,
    "modal-classes": "modal-secondary modal-dada",
    "body-classes": "py-0",
    "validate-on-mount": true,
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary",
    size: "sm",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, " Identificadores de " + _toDisplayString(_unref(CallDataModule).user?.customer?.full_name
						? _unref(CallDataModule).user.customer.full_name
						: _unref(CallDataModule).activeCall.call_number), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _withDirectives(_createVNode(IdentificatorsControl, {
        client: _unref(CallDataModule).user?._id,
        identifications: _unref(CallDataModule).user?.identification,
        onCreated: updateUserData,
        onDeleted: updateUserData
      }, null, 8, ["client", "identifications"]), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', false))),
          class: "ml-auto",
          type: "danger"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})